import { lorax } from '../urls';
import redirect from '../helpers/redirect';

export default async (companyId) => {
  console.debug('[SSO] Change company: Called.');
  redirect(`${lorax}/account/authenticating?company-id=${companyId}`);
};
